/**
 * @module modules/triage-status-sk
 * @description <h2><code>triage-status-sk</code></h2>
 *
 * Displays a button that shows the triage status of a cluster.  When the
 * button is pushed a dialog opens that allows the user to see the cluster
 * details and to change the triage status.
 *
 * @evt start-triage - Contains the new triage status. The detail contains the
 *    alert, cluster_type, full_summary, and triage.
 *
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TriageStatusSk", {
    enumerable: true,
    get: function() {
        return TriageStatusSk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
require("../tricon2-sk");
const _json = require("../json");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let TriageStatusSk = class TriageStatusSk extends _lit.LitElement {
    createRenderRoot() {
        return this;
    }
    render() {
        return (0, _lit.html)`
      <button title=${this.triage.message} @click=${this._start_triage} class=${this.triage.status}>
        <tricon2-sk class="inside_status" value=${this.triage.status}></tricon2-sk>
      </button>
    `;
    }
    _start_triage() {
        const detail = {
            full_summary: this.full_summary,
            triage: this.triage,
            alert: this.alert,
            cluster_type: this.cluster_type,
            element: this
        };
        this.dispatchEvent(new CustomEvent('start-triage', {
            detail,
            bubbles: true
        }));
    }
    constructor(...args){
        super(...args);
        this.triage = {
            status: 'untriaged',
            message: '(none)'
        };
        this.full_summary = null;
        this.alert = null;
        this.cluster_type = 'low';
    }
};
_ts_decorate([
    (0, _decorators.property)({
        type: Object
    }),
    _ts_metadata("design:type", typeof _json.TriageStatus === "undefined" ? Object : _json.TriageStatus)
], TriageStatusSk.prototype, "triage", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Object
    }),
    _ts_metadata("design:type", Object)
], TriageStatusSk.prototype, "full_summary", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Object
    }),
    _ts_metadata("design:type", Object)
], TriageStatusSk.prototype, "alert", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: String
    }),
    _ts_metadata("design:type", typeof ClusterType === "undefined" ? Object : ClusterType)
], TriageStatusSk.prototype, "cluster_type", void 0);
TriageStatusSk = _ts_decorate([
    (0, _decorators.customElement)('triage-status-sk')
], TriageStatusSk);
